import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { EngagementSelectComponent } from './engagement-select.component';
import { ContractModel } from 'src/app/core/models/contract.model';

@Component({
  selector: 'vex-engagement-select-modal',
  templateUrl: './engagement-select-modal.component.html',
  styleUrls: ['./engagement-select.component.scss'],
})
export class EngagementSelectModalComponent {
  @ViewChild(EngagementSelectComponent) table: EngagementSelectComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EngagementSelectModalComponent>,
  ) {}

  validate() {
    this.dialogRef.close(this.table.selectedContracts);
  }

  closeDialog() {
    this.dialogRef.close(null);
  }
}
